// Batch 33 · fork "data" (L2 sign-in message of a tenant in the platform Recycle Bin; L3 lead sheet "no balance — not required";
// P1B-F1 restore refused) — EN + AR. Merged into lib/i18n.js translations (big-file rule: new strings in their own file).
export const I18N_B33_DATA = {
  en: {
    itemSignoff: {
      noBalanceNotRequired: "No balance — not required (the head has no balance in either year and the sheet is empty; not counted by the lock)",
    },
    errors: {
      AUTH_WORKSPACE_REMOVED: "This workspace has been removed by the platform administrator.",
      AJE_ATTACHMENT_ENTRY_GONE: "The adjusting entry that this file belonged to no longer exists (the draft was discarded), so the file cannot be restored. Attach it again to another entry if it is still needed.",
    },
  },
  ar: {
    itemSignoff: {
      noBalanceNotRequired: "لا رصيد — غير مطلوب (لا رصيد للبند في أي من السنتين والورقة فارغة؛ لا تُحتسب عند القفل)",
    },
    errors: {
      AUTH_WORKSPACE_REMOVED: "أزال مدير المنصة مساحة العمل هذه.",
      AJE_ATTACHMENT_ENTRY_GONE: "قيد التسوية الذي كان هذا الملف مرفقًا به لم يعد موجودًا (تم تجاهل المسودة)، لذا لا يمكن استعادة الملف. أرفقه مجددًا بقيد آخر إن كان لا يزال مطلوبًا.",
    },
  },
};

export default I18N_B33_DATA;
